import {
  selectAllServiceLocations,
  useLoadEntityLocationsOnMount,
} from '@user/store/entityLocations'
import * as React from 'react'
import { FC } from 'react'
import { ServiceDialogRemoteProps } from './ServiceDialog'
import { useSelector } from 'react-redux'
import { ServiceDialogContent } from './ServiceDialogContent'
import { useGetLeadOppProductsOnMount } from '@user/store/leadOppProducts'

export const ServiceDialogRemoteContentWrapper: FC<ServiceDialogRemoteProps> = (
  props,
) => {
  const { entityId, entityType, preloadedServiceLocations } = props

  // WWM-18150 - when the caller (the Details page) already has this entity's current service
  // locations loaded, skip the independent fetch entirely rather than guarding around its
  // result. That fetch is what raced a subsequent entity switch and let a stale, previously
  // loaded entity's location leak into a new service. Callers without pre-loaded data (the
  // card-view modal) are unaffected - shouldRun stays true and behavior is unchanged.
  const serviceLocationsStatus = useLoadEntityLocationsOnMount(
    entityId,
    entityType,
    !preloadedServiceLocations,
  )
  const fetchedServiceLocations = useSelector(selectAllServiceLocations)
  const serviceLocations = preloadedServiceLocations ?? fetchedServiceLocations

  const leadProductStatus = useGetLeadOppProductsOnMount(entityId, entityType)

  const serviceLocationsLoading = preloadedServiceLocations
    ? leadProductStatus === 'pending'
    : serviceLocationsStatus === 'pending' || leadProductStatus === 'pending'

  return (
    <ServiceDialogContent
      {...props}
      serviceLocations={serviceLocations}
      serviceLocationsLoading={serviceLocationsLoading}
      entityId={entityId}
    />
  )
}
